// Local Docker previews must call the local API, not the production database.
const local = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname)
const serverURL = process.env.VUE_APP_SERVER_URL || (local ? `http://${window.location.hostname}:8087` : 'https://comaygao.com')

export default {
    serverURL,
    api: process.env.VUE_APP_API_URL || `${serverURL}/graphql`,
    defaultLang: 'vn',
}
